var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoIconRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 81,
    viewBox: "0 0 78 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.399274
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1676 60.5542C21.4061 61.0027 21.2358 61.5599 20.7872 61.7984C20.3387 62.0369 19.7815 61.8666 19.543 61.418C19.3045 60.9695 19.4749 60.4123 19.9234 60.1738C20.3719 59.9353 20.9291 60.1057 21.1676 60.5542Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3681 57.7891C26.6066 58.2376 26.4362 58.7948 25.9877 59.0333C25.5391 59.2718 24.9819 59.1014 24.7434 58.6529C24.5049 58.2044 24.6753 57.6472 25.1238 57.4087C25.5724 57.1702 26.1296 57.3405 26.3681 57.7891Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5696 55.0235C31.8081 55.472 31.6378 56.0292 31.1883 56.2681C30.7398 56.5066 30.1826 56.3363 29.9441 55.8878C29.7056 55.4392 29.876 54.882 30.3245 54.6435C30.7739 54.4046 31.3311 54.5749 31.5696 55.0235Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7701 52.2582C37.0086 52.7067 36.8382 53.2639 36.3888 53.5029C35.9402 53.7414 35.3831 53.571 35.1446 53.1225C34.9061 52.674 35.0764 52.1168 35.525 51.8783C35.9744 51.6393 36.5316 51.8097 36.7701 52.2582Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9708 49.4931C42.2092 49.9416 42.0389 50.4988 41.5904 50.7373C41.1409 50.9762 40.5837 50.8059 40.3452 50.3574C40.1068 49.9088 40.2771 49.3516 40.7265 49.1127C41.1751 48.8742 41.7323 49.0445 41.9708 49.4931Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1713 46.7278C47.4098 47.1763 47.2394 47.7335 46.7909 47.972C46.3423 48.2105 45.7852 48.0401 45.5467 47.5916C45.3082 47.1431 45.4785 46.5859 45.9271 46.3474C46.3756 46.1089 46.9328 46.2792 47.1713 46.7278Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3717 43.9626C52.6102 44.4112 52.4399 44.9684 51.9913 45.2069C51.5428 45.4454 50.9856 45.275 50.7471 44.8265C50.5086 44.3779 50.679 43.8207 51.1275 43.5822C51.576 43.3438 52.1332 43.5141 52.3717 43.9626Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5733 41.197C57.8118 41.6456 57.6414 42.2028 57.192 42.4417C56.7435 42.6802 56.1863 42.5099 55.9478 42.0613C55.7093 41.6128 55.8796 41.0556 56.3282 40.8171C56.7776 40.5781 57.3348 40.7485 57.5733 41.197Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5577 55.6459C18.7962 56.0944 18.6259 56.6516 18.1773 56.8901C17.7288 57.1286 17.1716 56.9583 16.9331 56.5097C16.6946 56.0612 16.8645 55.5031 17.313 55.2646C17.7616 55.0261 18.3192 55.1974 18.5577 55.6459Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7584 52.8808C23.9969 53.3293 23.8266 53.8865 23.378 54.125C22.9295 54.3635 22.3723 54.1931 22.1338 53.7446C21.8953 53.2961 22.0652 52.738 22.5137 52.4995C22.9623 52.261 23.5199 52.4322 23.7584 52.8808Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9597 50.115C29.1982 50.5636 29.0279 51.1208 28.5785 51.3597C28.1299 51.5982 27.5727 51.4279 27.3342 50.9793C27.0957 50.5308 27.2656 49.9727 27.7142 49.7342C28.1636 49.4953 28.7213 49.6665 28.9597 50.115Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1604 47.3499C34.3989 47.7984 34.2286 48.3556 33.7791 48.5946C33.3306 48.8331 32.7734 48.6627 32.5349 48.2142C32.2964 47.7657 32.4663 47.2076 32.9149 46.9691C33.3643 46.7301 33.9219 46.9014 34.1604 47.3499Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3609 44.5848C39.5994 45.0333 39.429 45.5905 38.9805 45.829C38.5311 46.0679 37.9739 45.8976 37.7354 45.4491C37.4969 45.0005 37.6668 44.4424 38.1162 44.2035C38.5647 43.965 39.1224 44.1362 39.3609 44.5848Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5614 41.8195C44.7999 42.268 44.6295 42.8252 44.181 43.0637C43.7325 43.3022 43.1753 43.1318 42.9368 42.6833C42.6983 42.2348 42.8682 41.6767 43.3167 41.4382C43.7652 41.1997 44.3229 41.3709 44.5614 41.8195Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7621 39.0543C50.0006 39.5029 49.8302 40.0601 49.3817 40.2986C48.9331 40.5371 48.376 40.3667 48.1375 39.9182C47.899 39.4696 48.0689 38.9116 48.5174 38.6731C48.9659 38.4346 49.5236 38.6058 49.7621 39.0543Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9634 36.2887C55.2019 36.7373 55.0315 37.2945 54.5821 37.5334C54.1336 37.7719 53.5764 37.6016 53.3379 37.153C53.0994 36.7045 53.2693 36.1464 53.7178 35.9079C54.1672 35.669 54.7249 35.8402 54.9634 36.2887Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9479 50.7376C16.1864 51.1861 16.016 51.7433 15.5675 51.9818C15.1189 52.2203 14.5617 52.0499 14.3233 51.6014C14.0843 51.152 14.2546 50.5948 14.7032 50.3563C15.1517 50.1178 15.7089 50.2882 15.9479 50.7376Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1486 47.9724C21.3871 48.421 21.2167 48.9782 20.7682 49.2167C20.3196 49.4552 19.7624 49.2848 19.5239 48.8363C19.285 48.3868 19.4553 47.8296 19.9039 47.5912C20.3524 47.3527 20.9096 47.523 21.1486 47.9724Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3499 45.2068C26.5884 45.6554 26.418 46.2126 25.9686 46.4515C25.5201 46.69 24.9629 46.5197 24.7244 46.0711C24.4854 45.6217 24.6558 45.0645 25.1043 44.826C25.5537 44.5871 26.1109 44.7574 26.3499 45.2068Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5506 42.4416C31.7891 42.8901 31.6187 43.4473 31.1693 43.6863C30.7207 43.9248 30.1636 43.7544 29.9251 43.3059C29.6861 42.8565 29.8565 42.2993 30.305 42.0608C30.7544 41.8218 31.3116 41.9922 31.5506 42.4416Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.751 39.6764C36.9895 40.125 36.8191 40.6822 36.3706 40.9207C35.9212 41.1596 35.364 40.9893 35.1255 40.5407C34.8865 40.0913 35.0569 39.5341 35.5063 39.2952C35.9548 39.0567 36.512 39.227 36.751 39.6764Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9518 36.9112C42.1903 37.3597 42.0199 37.9169 41.5714 38.1554C41.1228 38.3939 40.5657 38.2235 40.3272 37.775C40.0882 37.3256 40.2585 36.7684 40.7071 36.5299C41.1556 36.2914 41.7128 36.4617 41.9518 36.9112Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1522 34.146C47.3907 34.5946 47.2204 35.1518 46.7718 35.3902C46.3233 35.6287 45.7661 35.4584 45.5276 35.0098C45.2886 34.5604 45.459 34.0032 45.9075 33.7647C46.3561 33.5262 46.9133 33.6966 47.1522 34.146Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3538 31.3804C52.5923 31.829 52.4219 32.3862 51.9725 32.6251C51.524 32.8636 50.9668 32.6933 50.7283 32.2447C50.4893 31.7953 50.6597 31.2381 51.1082 30.9996C51.5576 30.7606 52.1148 30.931 52.3538 31.3804Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3378 45.8285C13.5767 46.2779 13.4064 46.8351 12.9579 47.0736C12.5093 47.3121 11.9521 47.1417 11.7132 46.6923C11.4747 46.2438 11.645 45.6866 12.0936 45.4481C12.5421 45.2096 13.0993 45.38 13.3378 45.8285Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5382 43.0632C18.7772 43.5127 18.6068 44.0698 18.1583 44.3083C17.7098 44.5468 17.1526 44.3765 16.9136 43.9271C16.6751 43.4785 16.8455 42.9213 17.294 42.6828C17.7425 42.4443 18.2997 42.6147 18.5382 43.0632Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7398 40.2976C23.9788 40.747 23.8084 41.3042 23.359 41.5432C22.9104 41.7817 22.3532 41.6113 22.1143 41.1619C21.8758 40.7134 22.0461 40.1562 22.4947 39.9177C22.9441 39.6787 23.5013 39.8491 23.7398 40.2976Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9402 37.5324C29.1792 37.9818 29.0088 38.539 28.5594 38.7779C28.1109 39.0164 27.5537 38.8461 27.3147 38.3967C27.0762 37.9481 27.2466 37.3909 27.6951 37.1524C28.1445 36.9135 28.7017 37.0838 28.9402 37.5324Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1409 34.7672C34.3799 35.2166 34.2095 35.7738 33.761 36.0123C33.3116 36.2513 32.7544 36.0809 32.5154 35.6315C32.2769 35.183 32.4473 34.6258 32.8967 34.3868C33.3452 34.1483 33.9024 34.3187 34.1409 34.7672Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3414 32.0021C39.5804 32.4515 39.4101 33.0087 38.9615 33.2472C38.513 33.4857 37.9558 33.3153 37.7168 32.8659C37.4783 32.4174 37.6487 31.8602 38.0972 31.6217C38.5458 31.3832 39.103 31.5535 39.3414 32.0021Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5419 29.2368C44.7808 29.6862 44.6105 30.2434 44.162 30.4819C43.7134 30.7204 43.1562 30.5501 42.9173 30.1006C42.6788 29.6521 42.8491 29.0949 43.2977 28.8564C43.7462 28.6179 44.3034 28.7883 44.5419 29.2368Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7435 26.4712C49.9824 26.9206 49.8121 27.4778 49.3626 27.7168C48.9141 27.9553 48.3569 27.7849 48.1179 27.3355C47.8795 26.887 48.0498 26.3298 48.4983 26.0913C48.9478 25.8523 49.505 26.0227 49.7435 26.4712Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7279 40.9202C10.9664 41.3687 10.7961 41.9259 10.3475 42.1644C9.89899 42.4029 9.34179 42.2325 9.1033 41.784C8.86481 41.3355 9.03516 40.7783 9.4837 40.5398C9.93224 40.3013 10.4894 40.4716 10.7279 40.9202Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9286 38.1549C16.1671 38.6034 15.9967 39.1606 15.5482 39.3991C15.0997 39.6376 14.5425 39.4673 14.304 39.0187C14.0655 38.5702 14.2358 38.013 14.6844 37.7745C15.1329 37.536 15.6901 37.7064 15.9286 38.1549Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1299 35.3893C21.3684 35.8378 21.1981 36.395 20.7486 36.634C20.3001 36.8725 19.7429 36.7021 19.5044 36.2536C19.2659 35.8051 19.4363 35.2479 19.8848 35.0094C20.3342 34.7704 20.8914 34.9408 21.1299 35.3893Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3306 32.624C26.5691 33.0726 26.3988 33.6298 25.9493 33.8687C25.5008 34.1072 24.9436 33.9369 24.7051 33.4883C24.4666 33.0398 24.637 32.4826 25.0855 32.2441C25.5349 32.0052 26.0921 32.1755 26.3306 32.624Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5311 29.8589C31.7695 30.3074 31.5992 30.8646 31.1507 31.1031C30.7012 31.3421 30.144 31.1717 29.9055 30.7232C29.6671 30.2747 29.8374 29.7175 30.2868 29.4785C30.7354 29.24 31.2926 29.4104 31.5311 29.8589Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7316 27.0937C36.9701 27.5423 36.7997 28.0995 36.3512 28.338C35.9027 28.5765 35.3455 28.4061 35.107 27.9576C34.8685 27.509 35.0388 26.9518 35.4874 26.7133C35.9359 26.4749 36.4931 26.6452 36.7316 27.0937Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9323 24.3285C42.1708 24.777 42.0004 25.3342 41.5519 25.5727C41.1033 25.8112 40.5461 25.6409 40.3076 25.1923C40.0692 24.7438 40.2395 24.1866 40.688 23.9481C41.1366 23.7096 41.6938 23.88 41.9323 24.3285Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1336 21.5629C47.3721 22.0114 47.2017 22.5686 46.7523 22.8076C46.3038 23.0461 45.7466 22.8757 45.5081 22.4272C45.2696 21.9786 45.4399 21.4214 45.8885 21.183C46.3379 20.944 46.8951 21.1143 47.1336 21.5629Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11804 36.0119C8.35653 36.4604 8.18618 37.0176 7.73764 37.2561C7.28911 37.4946 6.73191 37.3242 6.49342 36.8757C6.25493 36.4272 6.42481 35.8691 6.87335 35.6306C7.32188 35.3921 7.87955 35.5633 8.11804 36.0119Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3187 33.2466C13.5572 33.6951 13.3869 34.2523 12.9383 34.4908C12.4898 34.7293 11.9326 34.559 11.6941 34.1104C11.4556 33.6619 11.6255 33.1038 12.074 32.8653C12.5226 32.6268 13.0802 32.7981 13.3187 33.2466Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.52 30.481C18.7585 30.9295 18.5882 31.4867 18.1388 31.7257C17.6902 31.9642 17.133 31.7938 16.8945 31.3453C16.656 30.8968 16.8259 30.3387 17.2745 30.1002C17.7239 29.8612 18.2816 30.0325 18.52 30.481Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7207 27.7157C23.9592 28.1643 23.7889 28.7215 23.3395 28.9604C22.8909 29.1989 22.3337 29.0286 22.0952 28.58C21.8567 28.1315 22.0266 27.5734 22.4752 27.3349C22.9246 27.096 23.4822 27.2672 23.7207 27.7157Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9212 24.9506C29.1597 25.3991 28.9893 25.9563 28.5408 26.1948C28.0914 26.4338 27.5342 26.2634 27.2957 25.8149C27.0572 25.3664 27.2271 24.8083 27.6765 24.5693C28.125 24.3308 28.6827 24.5021 28.9212 24.9506Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1219 22.1855C34.3604 22.634 34.1901 23.1912 33.7416 23.4297C33.293 23.6682 32.7358 23.4978 32.4973 23.0493C32.2588 22.6007 32.4287 22.0427 32.8773 21.8042C33.3258 21.5657 33.8835 21.7369 34.1219 22.1855Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3224 19.4202C39.5609 19.8687 39.3905 20.4259 38.942 20.6644C38.4935 20.9029 37.9363 20.7326 37.6978 20.284C37.4593 19.8355 37.6292 19.2774 38.0777 19.0389C38.5262 18.8004 39.0839 18.9717 39.3224 19.4202Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.524 16.6546C44.7624 17.1031 44.5921 17.6603 44.1427 17.8993C43.6941 18.1378 43.1369 17.9674 42.8984 17.5189C42.66 17.0703 42.8298 16.5123 43.2784 16.2738C43.7278 16.0348 44.2855 16.206 44.524 16.6546Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50842 31.1035C5.74691 31.5521 5.57656 32.1093 5.12802 32.3478C4.67949 32.5863 4.12229 32.4159 3.8838 31.9674C3.64484 31.5179 3.81519 30.9608 4.26373 30.7223C4.71227 30.4838 5.26946 30.6541 5.50842 31.1035Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7089 28.3383C10.9474 28.7868 10.777 29.344 10.3285 29.5825C9.87993 29.821 9.32273 29.6506 9.08424 29.2021C8.84528 28.7527 9.01563 28.1955 9.46417 27.957C9.9127 27.7185 10.4699 27.8889 10.7089 28.3383Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9104 25.5727C16.1489 26.0212 15.9786 26.5784 15.5291 26.8174C15.0806 27.0559 14.5234 26.8855 14.2849 26.437C14.046 25.9876 14.2163 25.4304 14.6649 25.1919C15.1143 24.9529 15.6715 25.1233 15.9104 25.5727Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1109 22.8075C21.3494 23.2561 21.179 23.8133 20.7296 24.0522C20.2811 24.2907 19.7239 24.1204 19.4854 23.6718C19.2464 23.2224 19.4168 22.6652 19.8653 22.4267C20.3147 22.1878 20.8719 22.3581 21.1109 22.8075Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3116 20.0423C26.55 20.4908 26.3797 21.048 25.9312 21.2865C25.4817 21.5255 24.9245 21.3551 24.686 20.9066C24.4471 20.4572 24.6174 19.9 25.0669 19.661C25.5154 19.4225 26.0726 19.5929 26.3116 20.0423Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5121 17.2771C31.7506 17.7257 31.5802 18.2829 31.1317 18.5214C30.6831 18.7598 30.126 18.5895 29.8875 18.141C29.6485 17.6915 29.8189 17.1343 30.2674 16.8958C30.7159 16.6574 31.2731 16.8277 31.5121 17.2771Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7125 14.5119C36.951 14.9604 36.7807 15.5176 36.3321 15.7561C35.8836 15.9946 35.3264 15.8242 35.0879 15.3757C34.8489 14.9263 35.0193 14.3691 35.4678 14.1306C35.9164 13.8921 36.4736 14.0624 36.7125 14.5119Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9141 11.7463C42.1526 12.1948 41.9822 12.752 41.5328 12.991C41.0843 13.2294 40.5271 13.0591 40.2886 12.6106C40.0496 12.1611 40.22 11.6039 40.6685 11.3654C41.1179 11.1265 41.6751 11.2968 41.9141 11.7463Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.89809 26.1943C3.13705 26.6438 2.9667 27.201 2.51816 27.4394C2.06962 27.6779 1.51243 27.5076 1.27347 27.0582C1.03498 26.6096 1.20533 26.0524 1.65386 25.8139C2.1024 25.5754 2.6596 25.7458 2.89809 26.1943Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09853 23.4292C8.33749 23.8786 8.16714 24.4358 7.7186 24.6743C7.27006 24.9128 6.71287 24.7424 6.47391 24.293C6.23541 23.8445 6.40577 23.2873 6.8543 23.0488C7.30284 22.8103 7.86004 22.9807 8.09853 23.4292Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3001 20.6635C13.5391 21.1129 13.3687 21.6701 12.9193 21.909C12.4707 22.1475 11.9136 21.9772 11.6746 21.5278C11.4361 21.0792 11.6065 20.522 12.055 20.2835C12.5044 20.0446 13.0616 20.2149 13.3001 20.6635Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5005 17.8983C18.7395 18.3478 18.5691 18.9049 18.1197 19.1439C17.6712 19.3824 17.114 19.212 16.875 18.7626C16.6365 18.3141 16.8069 17.7569 17.2554 17.5184C17.7048 17.2794 18.262 17.4498 18.5005 17.8983Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7012 15.1331C23.9402 15.5825 23.7698 16.1397 23.3213 16.3782C22.8719 16.6171 22.3147 16.4468 22.0757 15.9974C21.8372 15.5488 22.0076 14.9916 22.457 14.7527C22.9055 14.5142 23.4627 14.6845 23.7012 15.1331Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9018 12.3679C29.1407 12.8173 28.9704 13.3745 28.5218 13.613C28.0733 13.8515 27.5161 13.6812 27.2771 13.2317C27.0386 12.7832 27.209 12.226 27.6575 11.9875C28.1061 11.749 28.6633 11.9194 28.9018 12.3679Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1024 9.60278C34.3414 10.0522 34.171 10.6094 33.7225 10.8479C33.274 11.0864 32.7168 10.916 32.4778 10.4666C32.2393 10.0181 32.4097 9.46087 32.8582 9.22238C33.3067 8.98389 33.8639 9.15424 34.1024 9.60278Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3038 6.83705C39.5427 7.28647 39.3724 7.84367 38.9229 8.08263C38.4744 8.32112 37.9172 8.15077 37.6783 7.70135C37.4398 7.25281 37.6101 6.69562 38.0586 6.45712C38.5081 6.21816 39.0653 6.38852 39.3038 6.83705Z",
    fill: "#AC5BCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.0331,
    y: 37.5949,
    width: 41,
    height: 41,
    rx: 5.5,
    transform: "rotate(-28 21.0331 37.5949)",
    stroke: "#B16AD2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconRight);
export default __webpack_public_path__ + "static/media/video-icon-right.f4eb3669fb9d3a7bb70755f4d9b5bb6b.svg";
export { ForwardRef as ReactComponent };